export default "__VITE_ASSET__8e5d0c16__"